import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6">
      <div className="max-w-4xl w-full">
        <div className="text-center bg-white rounded-3xl shadow-2xl p-12 relative overflow-hidden">
          {/* Logo com efeitos visuais */}
          <div className="relative mb-8">
            <img
              src="/logo-compact.webp"
              alt="Colônia de Férias - UBA Clube"
              className="max-w-[85%] h-auto mx-auto animate-bounce-in relative z-10"
            />

            {/* Efeito de brilho */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -skew-x-12 animate-pulse-slow pointer-events-none z-20"></div>

            {/* Efeito de shimmer */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/30 via-transparent to-white/20 opacity-0 animate-shimmer pointer-events-none z-5"></div>
          </div>

          {/* Título principal */}
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-display">
            Inscrições Abertas
          </h1>

          {/* Subtítulo */}
          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
            Faça agora a inscrição para a Colônia de Férias 2026.
          </p>

          {/* Botão de acesso */}
          <div className="mb-8">
            <Link
              to="/inscricao"
              className="inline-flex items-center px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg rounded-full transform transition-all duration-300 min-w-[280px] md:min-w-[240px]"
            >
              <span className="text-center w-full">Fazer Inscrição</span>
            </Link>
          </div>

          {/* Informações adicionais */}
          <div className="text-sm text-gray-500 space-y-2">
            <p>UBA Clube - Colônia de Férias 2026</p>
            <p className="font-medium">Sistema de Inscrições v2.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
